// Calculate the numeric value of a card for the game
export const calculateCardValue = (card, currentSum) => {
  const { value } = card;

  switch (value) {
    case 'A':
      // Ace is 1 or 11, choose the better option
      if (currentSum + 11 <= 99) {
        return 11;
      }
      return 1;
    case '2':
    case '3':
    case '5':
    case '6':
    case '7':
    case '8':
      return parseInt(value);
    case '4':
      return 0; // Skip card - no value added
    case '9':
      return 0; // Reverse card - no value added
    case '10':
      return -10; // Subtract 10
    case 'J':
    case 'Q':
      return 10; // Jack and Queen are 10
    case 'K':
      return 99 - currentSum; // King sets sum to exactly 99
    default:
      return 0;
  }
};

// Check if a card has special effects
export const hasSpecialEffect = (card) => {
  return card.value === '4' || card.value === '9';
};

// Get special effect description
export const getSpecialEffect = (card) => {
  switch (card.value) {
    case '4':
      return 'skip';
    case '9':
      return 'reverse';
    default:
      return null;
  }
};

// Handle player losing a round (subtract score, but don't go below 0)
export const handlePlayerLoss = (player, penalty = 1) => {
  const newScore = Math.max(0, (player.score || 0) - penalty);
  return { ...player, score: newScore };
};

// Check if the game should end
export const checkGameEnd = (currentSum, players) => {
  // Game ends if sum goes over 99
  if (currentSum > 99) {
    return { gameOver: true, reason: 'sum_exceeded' };
  }

  // Game ends if only one player has score > 0
  const alivePlayers = players.filter(player => player.score > 0);
  if (alivePlayers.length <= 1) {
    return {
      gameOver: true,
      reason: 'last_player_standing',
      winner: alivePlayers[0] || null
    };
  }

  return { gameOver: false };
};

// Check if a player should draw a card (when they have fewer than 3 cards)
export const shouldDrawCard = (playerHand) => {
  return playerHand.length < 3;
};

// Calculate next player index
export const getNextPlayerIndex = (currentIndex, players, direction, skipNext = false) => {
  const alivePlayers = players.filter(player => player.score > 0);
  if (alivePlayers.length <= 1) return currentIndex;

  let nextIndex = currentIndex;
  let steps = skipNext ? 2 : 1;

  for (let i = 0; i < steps; i++) {
    do {
      nextIndex = (nextIndex + direction + players.length) % players.length;
    } while (players[nextIndex].score <= 0);
  }

  return nextIndex;
};
